export interface IpensiiAuthConfig {
  redirect_uri: string; //'http://localhost:3000/loggin'
  authority: string; //'oauth2';
  client_id: string; //'ipensii';
  scope: string; //'openid';
  response_type: string; //'code';
  code_challenge_method: string; //'S256';
  grant_type: string; //'authorization_code';
}

export enum AuthStep {
  authorize = 'authorize',
  token = 'token',
}

export enum Authorities {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_TECH_ADMIN = 'ROLE_TECH_ADMIN',
  ROLE_HR_ADMIN = 'ROLE_HR_ADMIN',
  ROLE_HR = 'ROLE_HR',
}
